import { invoke } from '@shared/easyfy.decorators';
import { element, globalEvent } from '@shared/easyfy.core';
import { isMobile } from '@shared/easyfy.utils';
import { replaceContent } from '@clientShared/utils';
import Splide from '@splidejs/splide';
import { GetSubscriptionFlyoutView } from '@clientWebServices/productoptions.service';
import reviewsService from '@clientWebServices/reviews.service';

@invoke
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class Product {
  constructor() {}

  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'scroll-to-salesunit-selector',
          callback: this.scrollToSalesunitSelector,
        },
        {
          action: 'get-more-reviews',
          callback: this.loadMoreReviews,
        },
        {
          event: 'scroll-to-reviews',
          callback: this.scrollToReviews,
        },
      ],
    });

    window.addEventListener('update-subs-flyout', (() => {
      this.onUpdateSubscFlyout();
    }) as EventListener);

    window.addEventListener('initialize-product-images-slider', (() => {
      this.initializeProductImagesSlider();
    }) as EventListener);

    this.initializeProductImagesSlider();
  }

  initializeProductImagesSlider = () => {
    document.querySelectorAll('[data-container="product-images-slider"]').forEach((item) => {
      item.classList.add('splide');

      const slider = new Splide(item as HTMLElement, {
        type: 'slide',
        perPage: 1,
        arrows: false,
        lazyLoad: 'nearby',
        preloadPages: 1,
      });

      slider.on('pagination:mounted', function (data) {
        data.list.classList.add('with-dots');
      });

      slider.mount();
    });
  };

  scrollToSalesunitSelector(e: Event) {
    if (!isMobile()) return;
    const el = e?.target as HTMLElement;
    const elParent = el?.closest('.info') as HTMLElement;
    const hasSalesUnit = elParent?.dataset?.salesunits;
    if (hasSalesUnit && hasSalesUnit.toLowerCase() == 'true') {
      document.getElementById('salesunit-selector')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return false;
  }

  scrollToReviews() {
    const container = document.getElementById('review-container') as HTMLElement;
    const reviewDetails = container?.querySelector('details') as HTMLElement;

    reviewDetails?.setAttribute('open', '');
    container?.scrollIntoView({ behavior: 'smooth', block: 'center' });

    return false;
  }

  onUpdateSubscFlyout() {
    const subButton = element('[data-container="subscription-button"]') as HTMLElement;
    const searchProdId = subButton?.dataset?.searchproductid;
    if (subButton && searchProdId) {
      GetSubscriptionFlyoutView(searchProdId)
        .then((res) => {
          if (res?.data?.success && res?.data?.partialHtml != null) {
            const freqSelector = element('[data-container="subscription-freq"]');
            if (freqSelector) {
              replaceContent(freqSelector, res?.data?.partialHtml, 'replaceInnerHtml');
              freqSelector.setAttribute('data-updateflyout', 'false');
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    return false;
  }

  loadMoreReviews(e: Event) {
    e.preventDefault();
    e.stopPropagation();

    const target: HTMLElement = e.target as HTMLElement;
    const container: HTMLElement = target.closest('[data-container="product-reviews"]');
    const reviewsContainer = container?.querySelector('[data-container="reviews-container"]');
    const buttonContainer = container?.querySelector('[data-container="reviews-container-button"]');
    const button = container?.querySelector('[data-action="get-more-reviews"]');
    const page = button?.attributes['data-page']?.value;
    const productid = button?.attributes['data-product']?.value;
    const token = button?.attributes['data-token']?.value;

    reviewsService.ReviewListGetMore({ page: Number(page) + 1, productid: productid }, token).then((response) => {
      if (response?.data != null) {
        reviewsContainer.insertAdjacentHTML('beforeend', response.data.partial);
        buttonContainer.innerHTML = response.data.buttonpartial;
      }
    });
  }
}
